/* istanbul ignore file */
export * from './CategoryPageLoadingFallback';
